// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1518bc22","455":"3d78e835","488":"a81189c2"}[chunkId] + ".chunk.js";
};